import { del, get, patch, put } from "helpers/api_helper";

export const apiGetHelps = (params) => {
  return get("/master/faqs/", { params });
};

export const apiGetHelp = (id) => {
  return get(`/master/faqs/${id}`);
};

export const apiCreateHelp = (params) => {
  return put("/master/faqs/", params);
};

export const apiUpdateHelp = ({ id, ...params }) => {
  return patch(`/master/faqs/${id}`, params);
};

export const apiDeleteHelp = (id) => {
  return del(`/master/faqs/${id}`);
};

export const apiUpdateStatusHelps = (params) => {
  return patch("/master/faqs/update-status", params);
};
